import { createStrings } from '@utils/local';

export interface FAQItem {
  title: string;
  content: string;
}

export const faqStrings = createStrings({
  ja: {
    faqs: (): FAQItem[] => [
      {
        title: 'D2Dとはどんなサービスですか？',
        content:
          '海上コンテナ船の混載PORT TO DOORサービス、日本の輸入通関と日本国内配送を一つにした、中国から日本に発送できる便利、かつ料金もお得なサービスです。',
      },
      {
        title: 'D2Dの利用に事前登録が必要ですか？',
        content:
          'はい。初回ご利用の際に、無料アカウントを作成、D2D MEMBERSの申し込みが必要です。法人及び個人事業主はどなたでもご利用いただけます。個人の方はご利用できません。',
      },
      {
        title: 'D2Dは個人でも利用できますか？',
        content:
          'いいえ。個人の方はご利用できません。法人の方、及び個人事業主の方を対象としたサービスです。',
      },
      {
        title: 'D2Dの料金はどうなっていますか？',
        content:
          '従量課金のシンプルな料金体系です。\n日本の納品先ごとに基本料金があり、重量貨物（特に重い荷物）や長尺及び冬期料金（12月1日～3月31日）が適用される場合があります。',
      },
      {
        title: 'D2D料金の計算単位は何ですか？',
        content: '請求重量です。\n容積重量(KGS)と実重量(KGS)の大きい方を請求重量といたします。',
      },
      {
        title: 'D2Dの容積重量はどうやって計算しますか？',
        content: '容積(CBM or M3)×280KGS、Minimumミニマム 280KGSです。',
      },
      {
        title: 'D2Dに手数料は発生しますか？',
        content:
          'いいえ。D2Dの料金は、海上運賃、輸入通関料、日本国内配送料を含んだパッケージ価格で、手数料はありません。',
      },
      {
        title: '関税、消費税の立替払いをお願いできますか？',
        content:
          'いいえ。D2Dは、輸入時の関税及び消費税の立替はできません。\nつまり、料金と併せた請求書払いはできません。\nリアルタイム口座または、延納口座を事前にご用意してください。',
      },
      {
        title: '税関検査料金は含まれていますか？',
        content: 'いいえ。D2Dは、税関検査に伴う作業料は、別途ご請求します。',
      },
      {
        title: 'D2Dではどんなものが運べないでしょうか？',
        content:
          '中国及び日本が規制している品物と、D2Dの規制品は送ることが出来ません。主な品目は注意事項をご確認ください。\nhttps://d2dasia.com/instructions/',
      },
      {
        title: 'D2Dでは食品を運べますか？',
        content:
          'はい。D2Dは食品を送れます。\nただし食品届等の手続きについては、当社へ事前にご相談ください。',
      },
      {
        title: 'D2Dでは動植物を運べますか？',
        content: 'いいえ。D2Dは動植物を送れません。注意事項をご確認ください。',
      },
      {
        title: 'D2Dは日本のどの港へ輸入しますか？',
        content: '主に東京、名古屋、大阪、博多のいづれかの港へ輸入します。',
      },
      {
        title: 'D2Dは毎週何便ありますか？',
        content:
          '毎週7便あります。\n週7便のコンテナ船の中から、当社が選択したコンテナ船で輸送します。',
      },
      {
        title: 'D2Dの配達時間指定はできますか？',
        content: 'はい。チャーター便トラックの利用をご指定の場合、配達時間の指定はできます。',
      },
    ],
  },
});
